import React, { useState } from 'react';
import { getXeroConsentUrl } from '../services/api';
import BrandLockup from './BrandLockup';

export default function LoginScreen({ googleUser, onLogout }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  async function handleConnect() {
    setLoading(true);
    setError(null);
    try {
      const url = await getXeroConsentUrl();
      window.location.href = url;
    } catch (err) {
      setError('Could not connect to Xero. Please try again.');
      setLoading(false);
    }
  }

  return (
    <div className="login-screen">
      <div className="login-card">
        <BrandLockup className="login-brand" />

        {googleUser && (
          <div className="google-user-badge">
            {googleUser.avatar && (
              <img src={googleUser.avatar} alt={googleUser.name} className="google-user-avatar" />
            )}
            <span className="google-user-name">Signed in as {googleUser.name}</span>
            {onLogout && (
              <button className="btn-ghost-small" onClick={onLogout}>Sign out</button>
            )}
          </div>
        )}

        <h1 className="login-title">Connect to Xero</h1>
        <p className="login-sub">
          Connect your Xero account to start matching bank transactions to invoices using Claude AI.
        </p>

        {error && <p className="login-error">{error}</p>}

        <button
          className="btn-xero"
          onClick={handleConnect}
          disabled={loading}
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="10" r="10" fill="#13B5EA"/>
            <path d="M6 10l2.5 2.5L14 7" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          {loading ? 'Connecting...' : 'Connect with Xero'}
        </button>

        <p className="login-footer">
          Melon Accountants · Powered by Claude AI
        </p>
      </div>
    </div>
  );
}
